<div class="modal-header bg-head py-2">
  <h6 class="modal-title">Admin : Flashcard : Assign</h6>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="onCross()"
  ></button>
</div>
<div class="row">
  <div class="col-12 headersize py-2">
    <div class="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center px-3 ">
      <!-- Left: Path Title and Exam Info -->
      <div class="mb-2 mb-md-0">
        <!-- Path Title at the Top -->
        <span class="path-class m-0">{{ path }}</span>
      </div>
    </div>
  </div>
</div>

<div class="row">
  <div class="col-12 border-bottom headersize">
    <div class="d-flex flex-wrap align-items-center bg-deep-blue px-2 py-1 gap-2 gap-md-4">

      <!-- Only show exam info if available -->
      <ng-container *ngIf="courseName && examYearName && examAgencyName">
        <span class="fw-bold text-white section-label">Exam Agency Name&nbsp;:</span>
        <span class="fw-normal text-white-50 section-value me-3">{{ examAgencyName }}</span>
        <span class="fw-bold text-white section-label">Course Name&nbsp;:</span>
        <span class="fw-normal text-white-50 section-value me-3">{{ courseName }}</span>
        <span class="fw-bold text-white section-label">Year&nbsp;:</span>
        <span class="fw-normal text-white-50 section-value me-3">{{ examYearName }}</span>
      </ng-container>

      <!-- BUTTONS always shown, aligned right -->
      <div class="d-flex align-items-center ms-auto gap-2">
        <button
          type="button"
          *ngIf="savedCourseSelection"
          class="btn btn-sm border border-white text-white ms-1 ms-md-3 mt-2 mt-md-0"
          (click)="clearSelectedCourseWithRoute()"
          style="min-width:80px"
        >
          Clear
        </button>
        <button
          *ngIf="!FlashcardId"
          type="button"
          class="btn btn-sm btn-outline-primary select-course-btn px-4"
          (click)="openSelectPopUp()"
          style="min-width:140px; font-size: 14 px; font-weight: 400; border-radius: 3px; background: #fff;"
        >
          {{ savedCourseSelection ? 'Change course to assign multiple flashcards' :'Select course to assign multiple flashcards'}}
        </button>

      </div>
    </div>
  </div>
</div>


<div class="modal-body m-body flashcard-assign px-0">
  <form [formGroup]="assignForm">
    <div class="row" formArrayName="flashcardsArray">
      <div class="col-12 mb-4 question-height" *ngFor="let item of flashcardArray?.controls; let i = index;">
        <div [formGroupName]="i">
        <div class="col-12 bg-head-study py-2 px-3 d-flex flex-wrap justify-content-between align-items-center text-white">
            <!-- Flashcard ID (Centered) -->
            <div class="text-center d-flex align-items-center ">
              <h4 class="headertext-color mb-0">
                Flash Card: <span class="number-style">{{ FlashCards[i]?.FlashCard_ID }} {{FlashCards[i]?.Display_Order ? '': ''}} ({{FlashCards[i]?.Flashcard_Status_Type_Name}})</span>
              </h4>
              <input
              type="checkbox"
              formControlName="selected"
              class="form-check-input ms-2"
              (change)="onFlashcardSelectedChange(i, $event)"
              *ngIf="savedCourseSelection"
            />
            </div>

            <div class="d-flex gap-4">
          <!-- Created By & Date -->
          <div class="d-flex align-items-center">
            <h6 class="mb-0">
              <strong>Created By:</strong> {{ FlashCards[i]?.Created_By }}
               ({{ FlashCards[i]?.Creation_Date | date: 'short' }})
            </h6>


          </div>



          <!-- Updated By & Date -->
          <div class="d-flex align-items-center">
            <h6 class="mb-0">
              <strong>Updated By:</strong> {{ FlashCards[i]?.Updated_By }}
           ({{ FlashCards[i]?.Updation_Date | date: 'short' }})
            </h6>
          </div>
            </div>
            <div class="fs-5 fw-bold">
              <i class="fa fa-pencil-square-o pointer-cursor" *ngIf="!isEdit" aria-hidden="true"(click)="triggerParentFunction(FlashCards[i])"></i>
              {{FlashCards[i]?.Display_Order}}
            </div>
        </div>

        <div  class="row ms-4">
          <div class="col-md-7">
            <div class="row d-flex gap-2">
              <div class="col-12 col-md-5 mt-1"
              style="
              max-height: 480px;
              height: 430px;
              border: 2px solid grey;
              overflow-y: scroll;
              overflow-x: scroll;
            "
              >
                <div class="front-view" #frontView style="zoom: 62%; position:relative; top:10px" [innerHTML]="this.SanitizeHTML(FlashCards[i]?.Front_Side_Text ??'')">

                </div>
              </div>
              <div class="col-12 col-md-6 mt-1"
              style="
              max-height: 480px;
              height: 430px;
              border: 2px solid grey;
              overflow-y: scroll;
              overflow-x: scroll;
            "
              >

                <div class="back-view" #backView style="zoom: 62%; position:relative; top:10px" [innerHTML]="this.SanitizeHTML(FlashCards[i]?.Back_Side_Text??'')">

                </div>
              </div>

            </div>
          </div>
          <div class="col-md-5 d-flex flex-column align-items-end"    style="
              max-height: 480px;
              height: 460px;
              overflow-y: auto;
              ">
            <div class="col-12">
              <h4 class="my-1">Applicable Course Type</h4>
              <div class="row">
                <div class="d-flex flex-wrap gap-3" formArrayName="courseCategoryType">
                  <div
                    *ngFor="let ccType of getFormControlsForQuestion(i, 'courseCategoryType')?.controls; let cCI = index"
                    [formGroupName]="cCI"
                  >
                    <div>
                      <input
                        type="checkbox"
                        formControlName="SelectedInd"
                        (change)="onCourseCategoryTypeChange($event, ccType ,i)"
                      />
                      {{ ccType.value.CourseCategoryTypeName }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12">
              <h4 class="mb-2 mt-3">Applicable Courses</h4>
              <ng-container *ngFor="let item of courseCategoryList;let CCI=index">
                <div
  class="row my-3"
  *ngIf="getApplicableCourseTypeElementForAQuestion(i, CCI)?.get('SelectedInd')?.value">
                  <div class="col-12">
                    <div class="d-flex align-items-baseline gap-3">
                    <h5>{{ item.Description }}</h5>
                    <i class="fa fa-plus" (click)="addApplicableCourse(i,item)"></i>
                  </div>
                  <!-- <h6 *ngIf="checkifCategoryTypeNotEmpty(item.Code,i)">There are no Courses selected for {{ item.Description }}</h6> -->
                  </div>
                  <div class="col-12" *ngIf="!checkifCategoryTypeNotEmpty(item.Code,i)">
                    <div class="row px-2">
                      <div class="col-md-3 col-lg-3 col-xxl-3 px-1">
                        <span class="position-relative">Exam Agency
                          <small class="text-danger fs-5 position-absolute bottom-0">*</small>
                        </span>
                      </div>
                      <div class="col-md-3 col-lg-3 col-xxl-3 px-0">
                        <span class="position-relative">Course Name
                          <small class="text-danger fs-5 position-absolute bottom-0">*</small>
                        </span>
                      </div>
                      <div class="col-md-3 col-lg-3 col-xxl-3 px-0">
                        <span class="position-relative"> Difficulty Level
                          <small class="text-danger fs-5 position-absolute bottom-0">*</small>
                        </span>
                      </div>
                      <div class="col-md-3 col-lg-3 col-xxl-3 px-0">
                        <span class="position-relative">Year / Month
                          <small class="text-danger fs-5 position-absolute bottom-0">*</small>
                        </span>
                      </div>


                    </div>
                    <div class="row px-2" formArrayName="applicableCourses">
                      <ng-container
                        *ngFor="
                          let appExam of getFormControlsForQuestion(
                           i, 'applicableCourses'
                          )?.controls;
                          let aCI = index
                        "
                      >
                        <div
                          class="row my-1"
                          [formGroupName]="aCI"
                          *ngIf="appExam.value.type === item.Code && appExam.value.deleteInd ==='N'"
                        >
                          <div class="col-md-3 col-lg-3 col-xxl-3 px-1">
                            <select
                              class="form-control"
                              formControlName="examAgency"
                              (change)="fetchCourseBasedOnExam(appExam, item)"
                            >
                              <option [value]="null" hidden></option>
                              <option
                                class="border-bottom"
                                *ngFor="let s of appExam.value.examAgencyList"
                                [value]="s.Code"
                              >
                                {{ s.Description }}
                              </option>
                            </select>
                          </div>
                          <div class="col-md-3 col-lg-3 col-xxl-3 px-1">
                            <select
                              class="form-control"
                              formControlName="courseId"
                              (change)="fetchCourseYear(appExam, item)"
                            >
                              <option [value]="null" hidden></option>
                              <option
                                class="border-bottom"
                                *ngFor="let s of appExam.value.courseList"
                                [value]="s.Code"
                              >
                                {{ s.Description }}
                              </option>
                            </select>
                          </div>
                          <div class="col-md-3 col-lg-3 col-xxl-3 px-1">
                            <select
                              class="form-control"
                              formControlName="FlashcardDifficultyLevelTypeCode"
                            >
                              <option [value]="null" hidden></option>
                              <option
                                class="border-bottom"
                                *ngFor="let s of FlashCardDifficultyLevel"
                                [value]="s.Code"
                              >
                                {{ s.Description }}
                              </option>
                            </select>
                          </div>
                          <div class="col-md-3 col-lg-3 col-xxl-3 position-relative px-1">
                            <div class="d-flex">
                            <div style="width:92%;">
                            <select
                              class="form-control"

                              formControlName="examYear"
                              (change)="checkIfCourseYearAlreadySelected(appExam, getFormControlsForQuestion(
                                i, 'applicableCourses'
                               ),aCI)"
                            >
                              <option [value]="null" hidden></option>
                              <option
                                class="border-bottom"
                                *ngFor="let s of appExam.value.courseYear"
                                [value]="s.Code"

                              >
                                {{ s.Description }}
                              </option>
                            </select>
                            <small style="color:'red'" *ngIf="appExam.get('examYear')?.touched && appExam.get('examYear')?.hasError('sameCourse')"> The Course Year / Month is already selected.</small>
                            </div>
                            <span>
                              <i
                              (click)="deleteApplicableCourseElement(i,aCI)"
                              class="fa fa-trash pointer-cursor responsive-trash"
                            ></i>
                          </span>
                        </div>
                          </div>
                        </div>
                      </ng-container>
                    </div>
                  </div>
                </div>
              </ng-container>
            </div>
          </div>
        </div>
        </div>
      </div>
    </div>
  </form>

</div>
<div class="modal-footer">
  <button
    type="button"
    class=" bl-btn btn btn-sm"
    (click)="onSave()"
  >
    Save
  </button>
  <button
    type="button"
    class=" btn btn-sm bg-light border"
    (click)="this.onCross()">
    Cancel
  </button>
</div>
